// 第一阶段使用的本地示例数据（后续将由后端 API 提供）

export const currentUser = {
    name: '小码探险家',
    title: 'Lv4 探险家',
    level: 4,
    xp: 1250,
    xpToNext: 2000,
    badges: 12,
    streak: 5,
    projectsBuilt: 12,
    skillsMastered: 48
};

export const todaysChallenge = {
    tag: '新任务',
    title: '代码湾的失落宝藏',
    desc: '用「运动」积木指引海盗船穿过礁石迷宫，找到隐藏的宝藏！',
    progress: 33
};

export const learnCards = [
    {
        icon: 'puzzle',
        color: 'blue',
        title: '拼接积木',
        desc: '不用打字！拖动彩色积木，就能给角色下达指令。'
    },
    {
        icon: 'brush',
        color: 'orange',
        title: '尽情创作',
        desc: '画出自己的角色、录下声音，讲一个会动起来的故事。'
    },
    {
        icon: 'users',
        color: 'green',
        title: '分享给朋友',
        desc: '把作品发到广场，玩别人做的游戏，也从代码里学习。'
    }
];

// —— 任务地图：从下到上闯关，state: done | current | locked ——
export const quests = [
    {id: 'hello-world', title: '起点：你好世界', state: 'done', icon: 'medal', progress: 100},
    {id: 'sequences', title: '顺序山谷', state: 'done', icon: 'star', progress: 100},
    {id: 'loops', title: '循环丛林', state: 'current', icon: 'play', progress: 40},
    {id: 'variables', title: '变量高山', state: 'locked', icon: 'lock', progress: 0},
    {id: 'logic', title: '逻辑城堡', state: 'locked', icon: 'lock', progress: 0}
];

// —— 徽章墙 ——
export const badges = [
    {id: 'logic-lion', name: '逻辑狮', color: 'orange', icon: 'bolt', earned: true},
    {id: 'loop-legend', name: '循环传奇', color: 'blue', icon: 'star', earned: true},
    {id: 'creative-cat', name: '创意猫', color: 'green', icon: 'brush', earned: true},
    {id: 'variable-viper', name: '变量蛇', color: 'locked', icon: 'lock', earned: false}
];

// —— 我的作品 ——
export const myProjects = [
    {
        id: 'space-bug',
        title: '太空虫子大作战',
        desc: '保护你的披萨不被太空虫子偷走的小游戏。',
        status: '已分享',
        statusColor: 'green',
        thumb: 'space'
    },
    {
        id: 'my-monster',
        title: '我的虚拟怪兽',
        desc: '喂养并陪伴蓝色小怪兽波波一起玩耍！',
        status: '草稿',
        statusColor: 'gray',
        thumb: 'monster'
    }
];

// —— 作品广场 ——
export const featuredProject = {
    tag: '本周之星',
    title: '名人堂：太空大逃亡！',
    author: '@小天文学家',
    thumb: 'space'
};

export const galleryCategories = [
    {id: 'games', label: '游戏', color: 'blue', icon: 'play'},
    {id: 'animation', label: '动画', color: 'green', icon: 'brush'},
    {id: 'art', label: '绘画', color: 'orange', icon: 'brush'},
    {id: 'music', label: '音乐', color: 'gray', icon: 'bolt'}
];

export const galleryProjects = [
    {id: 'pet-sim', title: '怪兽养成记', author: '@代码小忍者', likes: 450, remixes: 89, thumb: 'monster'},
    {id: 'deep-sea', title: '深海绘画', author: '@海洋女孩', likes: 32, thumb: 'sea'},
    {id: 'neon-maze', title: '霓虹迷宫', author: '@逻辑小子', likes: 112, thumb: 'maze'},
    {id: 'drum', title: '打鼓机器', author: '@节奏大师', likes: 56, thumb: 'music'}
];

// —— 课程学习页（Lab 教程步骤）——
export const sampleLesson = {
    id: 'loops',
    title: '循环丛林 · 让小猫跳舞',
    intro: '在这一关，我们要用「重复」积木，让小猫不停地跳舞。跟着下面的步骤一步步来吧！',
    starter: {
        moduleName: '循环控制',
        sprite: 'Scratch 小猫',
        backdrop: '丛林舞台',
        sounds: '鼓点, 喵叫声',
        extensions: 'music'
    },
    steps: [
        {n: 1, title: '拖出「当绿旗被点击」', desc: '这是程序的开始。点击绿旗，小猫就会开始表演。', blockHint: '事件：当绿旗被点击', editorTip: '请在左侧积木分类里找到黄色「事件」，拖出「当绿旗被点击」。'},
        {n: 2, title: '加上「重复 10 次」', desc: '把重复积木套在外面，里面的动作就会做 10 遍。', blockHint: '控制：重复 10 次', editorTip: '请找到橙色「控制」，把「重复 10 次」接到绿旗积木下面。'},
        {n: 3, title: '放入「移动 10 步」和「等待 0.2 秒」', desc: '让小猫先走一步，再停一下，看起来就像在跳舞。', blockHint: '运动 + 控制：移动 / 等待', editorTip: '把蓝色「移动 10 步」和橙色「等待 0.2 秒」放进重复积木里面。'},
        {n: 4, title: '点击绿旗试试看！', desc: '看小猫动起来了吗？可以改改数字，让它跳得更快或更慢。', blockHint: '运行：点击绿旗', editorTip: '点击舞台上方的绿色旗帜，观察小猫是否开始跳舞。'}
    ]
};
